<template>
<div>
  <v-row>
    <v-col :cols="title_cols||6">
      <h2>
        <slot name="title">
          <v-icon v-if="icon">{{icon}}</v-icon>
          <span>{{title}}</span>
        </slot>
      </h2>
    </v-col>
    <v-col v-if="title_cols!=12" :cols="title_cols?(12-title_cols):6" class="r-col">
      <slot name="extra">
        <slot></slot>
      </slot>
    </v-col>
  </v-row>
  <hr class="hr-1">
  <br>
</div>
</template>

<script>
export default {
  props:['title','icon','title_cols'],
};
</script>

<style scoped>
.r-col{
  text-align: right;
}
.r-col>button{
  /* border-radius: 50px !important;
  border-width: 2px; */
}
</style>